import { Outlet, useMatch } from 'react-router';

import AgentAssistIntegration from '../../components/AgentAssistIntegration';
import DelayRendering from '../../components/core/DelayRendering';
import FollowUpReminders from '../../components/FollowUpReminders';
import HappyBirthday from '../../components/HappyBirthday';
import TaskReminders from '../../components/TaskReminders/TaskReminders';
import TwilioIntegration from '../../components/TwilioIntegration';
import UserGuiding from '../../components/UserGuiding';
import appConfiguration from '../../constants/appConfiguration';
import featureFlags from '../../constants/featureFlags';
import { useActionCableConsumer } from '../../hooks';
import { ActionCableContext } from '../../utils/actioncable';

const ExtrasLayoutRoute = () => {
  const cableConsumer = useActionCableConsumer();

  const isEmbeddedChromeExtension = !!useMatch('/current_customer_info');
  const hideCallIndicator = featureFlags.hideCallIndicator || isEmbeddedChromeExtension;

  return (
    <ActionCableContext.Provider value={cableConsumer}>
      <DelayRendering>
        <FollowUpReminders />
        <TaskReminders />
        <UserGuiding environment={appConfiguration.environment as 'staging' | 'production'} />
        <HappyBirthday />
      </DelayRendering>
      {hideCallIndicator || <TwilioIntegration />}
      <AgentAssistIntegration />
      <Outlet />
    </ActionCableContext.Provider>
  );
};

export default ExtrasLayoutRoute;
